import { isInstanceAnalyticsCollection } from "metabase/collections/utils";
import { getIsDashCardsRunning } from "metabase/dashboard/selectors";
import { GUEST_EMBED_EMBEDDING_TYPE } from "metabase/embedding/constants";
import { useSelector } from "metabase/redux";
import { Flex, Menu } from "metabase/ui";
import type { Dashboard } from "metabase-types/api";

import { useSharingModal } from "../../hooks/use-sharing-modal";

import { EmbedMenuItem } from "./MenuItems/EmbedMenuItem";
import { ExportPdfMenuItem } from "./MenuItems/ExportPdfMenuItem";
import { PublicLinkMenuItem } from "./MenuItems/PublicLinkMenuItem";
import { PublicLinkModals } from "./PublicLinkModals";
import { SharingMenu } from "./SharingMenu";
import type { DashboardSharingModalType } from "./types";
// DX-Comment: Importing getUserIsAdmin selector to check if the user is admin
import { getUserIsAdmin } from "metabase/selectors/user";

export function DashboardSharingMenu({ dashboard }: { dashboard: Dashboard }) {
  
  // DX-Comment: Getting isAdmin value from the redux store
  const isAdmin = useSelector(getUserIsAdmin);
  const { modalType, setModalType } =
    useSharingModal<DashboardSharingModalType>({
      resource: dashboard,
      resourceType: "dashboard",
    });

  const hasPublicLink = !!dashboard?.public_uuid;
  const isArchived = dashboard.archived;
  const isAnalytics =
    dashboard.collection && isInstanceAnalyticsCollection(dashboard.collection);

  const canShare = !isAnalytics;
  const isDashCardsRunning = useSelector(getIsDashCardsRunning);

  if (isArchived) {
    return null;
  }

  return (
    <Flex>
      <SharingMenu>
        <ExportPdfMenuItem dashboard={dashboard} loading={isDashCardsRunning} />
        {/* DX-Comment: Show public link and embed menu items only for admin users */}
        {canShare && isAdmin && (
          <>
            <Menu.Divider />
            <PublicLinkMenuItem
              hasPublicLink={hasPublicLink}
              onClick={() => setModalType("dashboard-public-link")}
            />
            <EmbedMenuItem
              onClick={() => setModalType(GUEST_EMBED_EMBEDDING_TYPE)}
            />
          </>
        )}
      </SharingMenu>
      <PublicLinkModals
        modalType={modalType}
        dashboard={dashboard}
        onClose={() => setModalType(null)}
      />
    </Flex>
  );
}
